const HeroSection = () => {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Stylized%20editorial%20flat%20lay%20composition%20featuring%20an%20artistic%20arrangement%20of%20premium%20sneakers%20designer%20accessories%20leather%20goods%20and%20fashion%20items%20on%20textured%20white%20marble%20and%20linen%20surfaces%20soft%20diffused%20natural%20daylight%20from%20large%20windows%20warm%20ivory%20beige%20and%20terracotta%20color%20palette%20sophisticated%20contemporary%20aesthetic%20with%20gentle%20shadows%20and%20elegant%20minimal%20styling%20high%20end%20fashion%20photography&width=1600&height=900&seq=kakobuy-hero-v2-x8&orientation=landscape"
        alt="Największy Kakobuy Spreadsheet w Polsce – starannie wybrane produkty"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/45"></div>
      <div className="relative z-10 w-full max-w-4xl mx-auto px-6 md:px-10 text-center">
        <p className="text-secondary-200 text-sm md:text-base tracking-widest uppercase mb-4 font-medium">
          Kakobuy Spreadsheet Polska
        </p>
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-6 leading-tight">
          Największy Kakobuy Spreadsheet w Polsce
        </h1>
        <p className="text-white/80 text-base md:text-lg max-w-2xl mx-auto mb-10 leading-relaxed">
          Odkryj najlepszy Kakobuy Spreadsheet z tysiącami starannie wybranych produktów, codziennie aktualizowanymi linkami oraz kompleksowymi poradnikami zakupowymi dla użytkowników z Polski i Europy.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-white font-semibold px-8 py-3.5 rounded-lg transition-all duration-300 whitespace-nowrap text-base shadow-lg shadow-primary-500/20 hover:shadow-primary-600/30 hover:-translate-y-0.5"
          >
            <i className="ri-file-list-3-line"></i>
            Kakobuy Sheet
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 bg-accent-500 hover:bg-accent-600 text-white font-semibold px-8 py-3.5 rounded-lg transition-all duration-300 whitespace-nowrap text-base shadow-lg shadow-accent-500/20 hover:shadow-accent-600/30 hover:-translate-y-0.5"
          >
            <i className="ri-shopping-cart-2-line"></i>
            Buy It Now
          </a>
        </div>
        <div className="mt-12 flex items-center justify-center gap-2 text-white/60 text-sm">
          <i className="ri-arrow-down-line animate-bounce"></i>
          <span>Przeglądaj kategorie</span>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;